export namespace Loader {
  export enum Size {
    Small = 'sm',
    Normal = 'md',
    Large = 'lg'
  }
}
